import { z } from "zod";

import {
  V1ChatCompletionRequestSchema,
  V1ChatCompletionResponseSchema,
  V1CompletionResponseSchema,
  V1EmbeddingRequestSchema,
  V1EmbeddingResponseSchema,
  V1TextCompletionRequestSchema,
} from "./completions/completions.models";
import { OpenAIInferenceErrorResponseSchema } from "./openai-error.models";
import {
  V1ResponsesCreateRequestSchema,
  V1ResponsesResponseSchema,
} from "./responses/responses.models";

export const OpenAIInferenceRequestSchema = V1ChatCompletionRequestSchema.or(
  V1TextCompletionRequestSchema,
)
  .or(V1ResponsesCreateRequestSchema)
  .or(V1EmbeddingRequestSchema);

export type OpenAIInferenceRequest = z.infer<
  typeof OpenAIInferenceRequestSchema
>;

export type OpenAIInferenceResponse = z.infer<
  typeof OpenAIInferenceResponseSchema
>;

export const CerebrasInferenceErrorResponseSchema = z
  .object({
    code: z.string().nullable(),
    message: z.string().nullish(),
    param: z.string().nullish(),
    type: z.string().nullish(),
  })
  .passthrough()
  .or(z.object({ detail: z.string() }).passthrough());

export type CerebrasInferenceErrorResponse = z.infer<
  typeof CerebrasInferenceErrorResponseSchema
>;

export const OpenAIInferenceResponseSchema = V1CompletionResponseSchema.or(
  V1ChatCompletionResponseSchema,
)
  .or(V1ResponsesResponseSchema)
  .or(V1EmbeddingResponseSchema)
  .or(OpenAIInferenceErrorResponseSchema)
  .or(CerebrasInferenceErrorResponseSchema);
